import { ChatPromptQueueStrip } from '@/components/chat/chat-prompt-queue-strip';

import { useAgentChatContext } from './agent-chat-provider';

export function PromptQueueStrip() {
  const { promptQueue, isSending, setComposerDraft, pendingDecision } =
    useAgentChatContext();

  // Editing only while there is a prompt bar: while a decision panel is up
  // there is none.
  return (
    <ChatPromptQueueStrip
      queueKey={promptQueue.queueKey}
      isBusy={isSending}
      canEdit={!pendingDecision}
      onResume={promptQueue.resume}
      onEditItem={setComposerDraft}
    />
  );
}
